import { vaultRequest } from './request';

const REPORT_INCORRECT_KYB = `
mutation VaultIncorrectKybSupportReport(
  $orgAddressCity: String!
  $orgAddressState: String!
  $orgAddressStreet: String!
  $orgAddressZip: String!
  $orgEin: String!
  $orgLegalName: String!
  $raiseCampaignId: String!
  $raiseUserId: String!
  $comment: String
) {
  response: vaultIncorrectKybSupportReport(
    orgAddressCity: $orgAddressCity
    orgAddressState: $orgAddressState
    orgAddressStreet: $orgAddressStreet
    orgAddressZip: $orgAddressZip
    orgEin: $orgEin
    orgLegalName: $orgLegalName
    raiseCampaignId: $raiseCampaignId
    raiseUserId: $raiseUserId
    comment: $comment
  ) {
    success
    errors {
      type
      message
    }
  }
}
`;

export const reportIncorrectKyb = async (kybForm: {
  raiseCampaignId?: string;
  raiseUserId?: string;
  orgLegalName: string;
  orgEin: string;
  orgAddressStreet: string;
  orgAddressCity: string;
  orgAddressState: string;
  orgAddressZip: string;
  comment?: string;
}): Promise<boolean> => {
  const reportKYBRes = await vaultRequest(REPORT_INCORRECT_KYB, kybForm);
  const reportKYBJson = await reportKYBRes.json();
  if (reportKYBJson.errors) {
    throw new Error(`Could not send email to report incorrect kyb`);
  }
  return reportKYBJson.data.response.success;
};
